<button mat-icon-button type="button" tabindex="-1" (click)="onResize()">
  <mat-icon fontSet="project-titan" [fontIcon]="fontIcon"></mat-icon>
</button>